module.exports = __webpack_public_path__ + "static/media/折线@2x.0c9c938e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/折线@2x.png
// module id = 1201
// module chunks = 0